import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"
import axios from "axios"
import Img from "gatsby-image"
import Rating from "@material-ui/lab/Rating"
import { useTranslation } from "react-i18next"
import SiteContext from "../context/siteContext"

import { makeStyles, Button, Typography, Box } from "@material-ui/core"

import SigninForm from "../components/signin-form"
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart"
import BookImage from "../../static/images/book-image.png"
import { LazyLoadImage } from "react-lazy-load-image-component"

const windowGlobal = typeof window !== "undefined" && window

const Slides = ({ slideBooks, openSnackbar, ishome = false }) => {
  const classes = useStyles()
  const [t, i18n] = useTranslation()
  const [signFormOpen, setSignFormOpen] = useState(false)
  const [currencyRateState, setCurrencyRate] = useState(1)
  const [countItem] = useState({ count: 1 })
  const { isActiveCart, setIsActiveCart, setCartItemContentLenght } = useContext(SiteContext)

  useEffect(() => {
    if (windowGlobal) {
      if (windowGlobal.localStorage.getItem("currencyKey") === "TRY") {
        setCurrencyRate(windowGlobal.sessionStorage.getItem("currencyRate"))
      }
    }
  }, [])

  let bookItems =
    slideBooks.book_items && slideBooks.book_items !== 0
      ? slideBooks.book_items.filter(item => item.type === "paper")
      : ""

  let bookItem = bookItems.length > 0 ? bookItems[0] : {}

  const { type, price } = bookItem

  let bookPrice = price > 0 ? price : ""

  let jwtForProfile
  if (windowGlobal) {
    jwtForProfile = windowGlobal.sessionStorage.getItem("jwtCode")
  }
  const signFormClose = () => {
    setSignFormOpen(false)
  }
  const handleOpenSnackbar = () => {
    openSnackbar()
  }

  const handleAddToCard = () => {
    if (jwtForProfile) {
      axios
        .post(
          `${process.env.GATSBY_API_URL}/add-cart-item`,
          {
            quantity: countItem.count,
            book: slideBooks.strapiId ? slideBooks.strapiId : slideBooks.id,
            format: "paper",
          },
          { headers: { Authorization: `Bearer ${jwtForProfile}` } }
        )
        .then(() => {
          handleOpenSnackbar()
          if (!isActiveCart) {
            setIsActiveCart(true)
          }
          axios
            .get(`${process.env.GATSBY_API_URL}/get-cart-items-by-type/paper`, {
              headers: {
                Authorization: `Bearer ${jwtForProfile}`,
              },
            })
            .then(res => {
              setCartItemContentLenght(res.data.items.length)
            })
        })
    } else {
      setSignFormOpen(true)
    }
  }

  return (
    <>
      <SigninForm isOpen={signFormOpen} onClose={signFormClose} />
      <div className={classes.slide}>
        <Box className={classes.bookBoxContainer}>
          {!slideBooks.quantity && <div className={classes.outOfStock}>{t("singleBook.outOfStock")}</div>}
          <Link to={`/${i18n.language}/books/${slideBooks.strapiId ? slideBooks.strapiId : slideBooks.id}`}>
            {slideBooks.image && slideBooks.image.publicURL ? (
              // <img
              // src={slideBooks.image && slideBooks.image.publicURL}
              // className={classes.bookImage}
              // style={{ width: "169px", height: "244px"}}
              // />
              <Img fixed={slideBooks.image.childImageSharp.fixed} className={classes.bookImage} />
            ) : slideBooks.image !== null && slideBooks.image.formats !== null ? (
              <>
                {/* <img
                  src={
                    slideBooks.image !== null
                      ? `${process.env.GATSBY_API_URL}${slideBooks.image.formats.small.url}`
                      : BookImage
                  }
                  alt={slideBooks.title}
                  className={classes.bookImage}
                /> */}
                <LazyLoadImage
                  alt={slideBooks.title}
                  width={175}
                  height={242}
                  effect="blur"
                  threshold={20}
                  className={classes.bookImage}
                  src={
                    slideBooks.image !== null
                      ? slideBooks.image.formats.small
                        ? `${process.env.GATSBY_API_URL}${slideBooks.image.formats.small.url}`
                        : BookImage
                      : BookImage
                  }
                />
              </>
            ) : (
              <>
                <img
                  src={slideBooks.image ? `${process.env.GATSBY_API_URL}${slideBooks.image.url}` : BookImage}
                  alt={slideBooks.title}
                  className={classes.bookImage}
                  width="175"
                  height="242"
                />
              </>
            )}

            {ishome ? (
              <Typography variant="subtitle1" component="h3">
                {slideBooks.title}
              </Typography>
            ) : (
              <Typography variant="subtitle1" component="h3">
                {i18n.language === "en" && slideBooks.title && slideBooks.title}
                {i18n.language === "ar" && slideBooks.title_ar && slideBooks.title_ar}
                {i18n.language === "tr" && slideBooks.title_tr && slideBooks.title_tr}
              </Typography>
            )}
          </Link>
          <div className="rating-and-price">
            {slideBooks.rating ? (
              <Rating name="half-rating-read" defaultValue={slideBooks.rating} precision={0.5} readOnly />
            ) : (
              <Rating name="half-rating-read" defaultValue={0} precision={0.5} readOnly />
            )}
            <Typography className={classes.bookDetails}>
              {type && t("singleBook.type")} {bookPrice && t("singleBook.price")}{" "}
              {bookPrice && parseFloat(bookPrice * currencyRateState).toFixed(2)}
              {bookPrice && (currencyRateState > 1 ? <>&#8378;</> : <>&#36;</>)}
            </Typography>
          </div>
          <div className="add-to-cart-btn">
            <Button
              variant="contained"
              color="default"
              className={classes.addToCartBtn}
              onClick={handleAddToCard}
              disabled={!slideBooks.quantity && true}
              startIcon={<ShoppingCartIcon className={classes.addToCartBtnIcon} />}
            >
              {t("singleBook.addToCart")}
            </Button>
          </div>
        </Box>
      </div>
    </>
  )
}
export default Slides

const useStyles = makeStyles(theme => ({
  slide: {
    margin: "0 auto",
    textAlign: "center",
    outlineWidth: 0,
    marginBottom: "1.5rem",
    "&:focus": {
      outlineWidth: 0,
    },
    "& *": {
      outlineWidth: 0,
      maxWidth: 175,
      textAlign: "center",
      margin: "0 auto",
      textDecoration: "none",
    },
    "& img": {
      // margin: '0 auto',
      textAlign: "center",
      // border: "3px solid #000",
      // borderRadius: 10,
      boxShadow: "0px 0px 4px 0px rgb(0 0 0 / 78%)",
    },
    "& p": {
      margin: "0 auto",
      fontSize: "1.2rem",
      color: "#003e96",
    },
    "& h3": {
      marginTop: "1rem",
      textDecoration: "none",
      color: "#003e96",
    },
    "& .add-to-cart-btn": {
      display: "none",
    },
    "& .rating-and-price": {
      marginTop: 1,
    },
    "&:hover .rating-and-price": {
      display: "none",
    },
    "&:hover .add-to-cart-btn": {
      display: "block",
    },
  },
  bookDetails: {
    direction: "ltr",
    color: "#092b5b !important",
    fontSize: "1rem !important",
  },
  addToCartBtn: {
    color: "#003e96",
    borderRadius: 10,
    marginTop: "1.1rem",
  },
  addToCartBtnIcon: {
    width: "1.5rem",
    height: "1.5rem",
    fontSize: "1.5rem",
  },
  bookBoxContainer: {
    margin: "2rem auto",
    position: "relative",
  },
  outOfStock: {
    backgroundColor: "#003e96",
    width: 68,
    // padding: 11,
    // padding: "14px ​11px 11px",
    padding: "13px 11px 11px",
    borderRadius: "50%",
    position: "absolute",
    right: "-27px",
    top: "-27px",
    color: "#fff",
    fontWeight: "600",
    zIndex: 1,
  },
  bookImage: {
    float: "center",
    marginBottom: 12,
    objectFit: "cover",
  },
}))
